export default function(number, increment) {
    return (parseInt(number) + parseInt(increment));
}
